import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { NotificationEntity, useGetDronesQuery } from '@src/core/features';
import { setSelectedDrone } from '@src/features/drone/redux';
import type { AppDispatch } from '@src/store';
import { resolveNotificationTarget } from './notification-target';

/** Opens the page a notification points at. Returns whether it navigated, so the caller can close its panel. */
export const useNotificationNavigation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { pathname } = useLocation();
  // Already fetched by the sidebar, so this reads the shared cache rather than adding a request.
  const { data: dronesResponse } = useGetDronesQuery();
  const drones = dronesResponse?.data;

  return React.useCallback(
    (notification: NotificationEntity): boolean => {
      const target = resolveNotificationTarget(notification, drones ?? [], pathname);
      if (!target) return false;

      if (target.drone) dispatch(setSelectedDrone(target.drone));
      navigate(target.url);
      return true;
    },
    [drones, pathname, navigate, dispatch],
  );
};
